import { PlusCircleIcon } from "@heroicons/react/outline";
import { useDispatch } from "react-redux";
import { createDiscussionSliceActions } from "../../redux/features/Modal/createDiscussionSlice";
import RoomsCardData from "../RoomsCardData/RoomsCardData";

const RoomsCard = ({ roomsData }) => {
  const dispatch = useDispatch();

  const openModal = () => {
    dispatch(createDiscussionSliceActions.enebleModal());
  };

  return (
    <div className="px-3">
      <div className="flex justify-between items-center">
        <h1 className="text-xl">My Rooms</h1>
        <div className="flex items-center space-x-2">
          <button
            onClick={openModal}
            className="flex items-center text-sm text-white bg-green-600 rounded-lg hover:shadow-md px-4 py-2"
          >
            Create Room <PlusCircleIcon className="h-5 ml-3" />{" "}
          </button>
        </div>
      </div>
      <div className="flex flex-col space-y-5">
        {roomsData?.map(
          ({ id, data: { roomName, createdUser, privacyMode, language } }) => (
            <RoomsCardData
              key={id}
              roomId={id}
              title={roomName}
              createdUser={createdUser}
              language={language}
            />
          )
        )}
      </div>
    </div>
  );
};

export default RoomsCard;
